$(function () {

    // tooltips
    function onHoverToggleTooltip(e) {



        var $this = $(this),
            caption = $this.attr('data-caption'),
            type = e.type,
            offset = $this.offset(),
            xOffset = e.pageX - offset.left + 10,
            yOffset = e.pageY - offset.top + 18;

        if (!caption.length) return;

        if (type == 'mouseenter') {
            $this
                .append('<div class="tooltip-custom">' + caption + '</div>')
                .find('.tooltip-custom')
                .hide()
                .fadeIn(100)
            $this
                .find('.tooltip-custom')
                .css('top', (yOffset) + 'px')
                .css('left', (xOffset) + 'px');
        } else if (type == 'mouseleave') {
            $this
                .find('.tooltip-custom')
                .fadeOut(100, function () {
                    $(this).remove()
                });
        } else if (type == 'mousemove') {
            $this
                .find('.tooltip-custom')
                .css('top', (yOffset) + 'px')
                .css('left', (xOffset) + 'px');
        }
    }

    $(document.querySelectorAll('.js-popover-hover')).on({
        mouseenter: onHoverToggleTooltip,
        mouseleave: onHoverToggleTooltip,
        mousemove: onHoverToggleTooltip
    });

});
